import { defineFormSchema } from '../../../shared/data/formSchema';
import { CALENDAR_EVENT_TYPE_OPTIONS } from '../utils/calendar.constants';
export const calendarFormSchema = defineFormSchema({
  id: 'calendar.event.create',
  fields: [
    { name: 'title', label: 'Titolo', required: true, primary: true, table: { minWidth: 190, order: 0 } },
    { name: 'description', label: 'Descrizione', type: 'textarea' },
    { name: 'amount', label: 'Importo', table: false },
    { name: 'date', label: 'Data', type: 'date', required: true, table: { order: 2 } },
    { name: 'time', label: 'Ora', type: 'time', required: true, table: { order: 3 } },
    { name: 'endDate', label: 'Data fine', type: 'date', table: { hidden: true } },
    { name: 'durationCustom', label: 'Durata personalizzata', required: true, table: false },
    { name: 'duration', label: 'Durata', table: { hidden: true } },
    {
      name: 'type',
      label: 'Tipo',
      type: 'select',
      options: CALENDAR_EVENT_TYPE_OPTIONS,
      table: { order: 6 },
    },
    { name: 'location', label: 'Luogo', table: { hidden: true } },
    {
      name: 'priority',
      label: 'Priorità',
      type: 'select',
      options: [
        { value: 'alta', label: 'Alta' },
        { value: 'media', label: 'Media' },
        { value: 'bassa', label: 'Bassa' },
      ],
      table: { order: 7 },
    },
    { name: 'clientId', label: 'Cliente', table: false },
    { name: 'supplierId', label: 'Fornitore', table: false },
    { name: 'attendees', label: 'Personale', table: { hidden: true } },
  ],
});
